import React, {useEffect} from 'react'
import {Button} from 'react-bootstrap'
import {KTSVG} from '../../../../_metronic/helpers'
import {useFormik} from 'formik'
import {initRouteManageFormValeus, overwriteOptions, statusOptions} from '../_model'
import ReactSelectBox from '../../../utils/components/ReactSelectBox'
import {useRouteManagement} from '../RouteManagementProvider'
import {BASE_URL} from '../../config'
import {useMutation, useQueryClient} from 'react-query'
import axios from 'axios'
import toast from 'react-hot-toast'
import {handleAxiosError} from '../../../utils/helperFunction/_helper'

const UPDATE_STATUS_URL = `${BASE_URL}/api/protect/updateRouteSenderRoleStatus`

const UpdateSenderRouteRole = () => {
  const queryClient = useQueryClient()

  const {selectRouteSenderRole} = useRouteManagement()

  const {mutateAsync: changeRolesStatusType} = useMutation({
    mutationFn: async (data: {status: number}) => {
      const response = await axios.put(
        `${UPDATE_STATUS_URL}?status=${data.status}&rulesId=${selectRouteSenderRole?.id}`
      )
      console.log(response)
    },
    onSuccess: () => {
      toast.dismiss()
      toast.success('Successfully updated & Getting updated data..')
      queryClient.invalidateQueries(['createRouteSenderRoles'])
      resetForm()
    },
    onError: (error: Error) => {
      toast.dismiss()
      const message = handleAxiosError(error)
      toast.error(message)
    },
  })

  const formik = useFormik({
    initialValues: {
      status: '',
    },
    onSubmit: async (values) => {
      try {
        toast.loading('Processing..')
        const status = values.status.toLowerCase() === 'active' ? 1 : 0

        await changeRolesStatusType({status})
      } catch (error) {
        console.log(error)
      }
    },
  })

  const resetForm = () => formik.resetForm()

  useEffect(() => {
    if (selectRouteSenderRole) {
      formik.setValues({
        status: selectRouteSenderRole.status.toLowerCase() === 'active' ? 'Active' : 'Inactive',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectRouteSenderRole])

  return (
    <div className='modal fade' tabIndex={-2} id='kt_modal_2'>
      <div className='modal-dialog modal-lg'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Update</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>

          <form onSubmit={formik.handleSubmit}>
            <div className='modal-body'>
              {/* <div className='fv-row mb-7'>
                <label className='fw-semibold fs-6 mb-2'>Name</label>

                <input
                  {...formik.getFieldProps('name')}
                  placeholder='name'
                  type='text'
                  className='form-control form-control custom-input mb-3 mb-lg-0'
                  autoComplete='off'
                />
              </div> */}

              {/* <div className='fv-row mb-7'>
              <label className='fw-semibold fs-6 mb-2'>Overwrite Option</label>

              <ReactSelectBox
                formik={formik}
                fieldValue='type'
                placeholder='Select value'
                options={overwriteOptions}
              />
            </div> */}

              <div className='fv-row mb-7'>
                <label className='fw-semibold fs-6 mb-2'>Status</label>

                <ReactSelectBox
                  formik={formik}
                  fieldValue='status'
                  placeholder='Select value'
                  options={statusOptions}
                />
              </div>

              <div className='modal-footer'>
                <Button variant='light' data-bs-dismiss='modal' aria-label='Close'>
                  Cancel
                </Button>
                <Button type='submit' variant='primary' data-bs-dismiss='modal' aria-label='Close'>
                  Update
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default UpdateSenderRouteRole
